module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/dropside-active.a0670dbf.svg";